import { createStorage } from "..";

const bannerStorage = createStorage({
  prefix: "banner_",
  type: "local",
});

export { bannerStorage };
